import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';

// Definitions panel — same pattern as Analytics of Empresas/Contactos
const PANEL_DEFINITIONS = [
  ['Empresas (KPI)', 'Empresas activas de las que eres responsable / empresas activas totales del CRM.'],
  ['Contactos (KPI)', 'Contactos de tu cartera / contactos totales del CRM.'],
  ['Oportunidades a trabajar (KPI)', 'Oportunidades en Detectada (prospecto) o Propuesta (en preparación): las únicas que requieren acción comercial desde este panel. Tuyas / totales del CRM.'],
  ['Ganadas (KPI)', 'Importe asignado a TDS de las oportunidades ganadas en el año en curso. Tuyo / total de la compañía. Si aparece "-" es que no hay importe TDS registrado.'],
  ['Agenda semanal', 'Cada día muestra primero lo que ya tienes comprometido (reuniones, llamadas, tareas y seguimientos con fecha) y después una propuesta automática de hasta 3 contactos a cultivar. La propuesta no es editable: si un día es festivo, márcalo y sus acciones se contabilizan como no realizables.'],
  ['Hoy', 'Tus compromisos de hoy más los 3 contactos que el sistema propone cultivar según su cadencia.'],
  ['Urgentes', 'Oportunidades que llevan demasiados días sin movimiento y necesitan avanzar etapa o registrar actividad.'],
  ['Oportunidades', 'Oportunidades que requieren atención por plazo, valor o inactividad.'],
  ['A cultivar', 'Contactos que han superado su umbral de días sin contacto según la cadencia asignada.'],
  ['Puntos de color', 'Ámbito de la empresa: azul = TYPSA, verde = pública, morado = privada. Se muestra a la izquierda del nombre. Si no se puede determinar el ámbito, no se pinta el punto.'],
];

const DefinitionsPanel = () => (
  <Sheet>
    <SheetTrigger asChild>
      <button
        type="button"
        className="text-[11px] text-muted-foreground hover:text-foreground underline decoration-dotted"
        data-testid="panel-definitions-link"
      >
        ¿Cómo se calculan estas métricas?
      </button>
    </SheetTrigger>
    <SheetContent side="right" className="w-full sm:max-w-lg overflow-y-auto" data-testid="panel-definitions-sheet">
      <SheetHeader>
        <SheetTitle>Definiciones - Panel</SheetTitle>
      </SheetHeader>
      <div className="mt-4 space-y-4 text-sm">
        {PANEL_DEFINITIONS.map(([title, text]) => (
          <div key={title}>
            <div className="font-semibold text-sm mb-0.5">{title}</div>
            <p className="text-xs text-muted-foreground leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </SheetContent>
  </Sheet>
);

export default DefinitionsPanel;
